import React from 'react';
export var DeepnoteComponent = function (_a) {
    var block = _a.block;
    console.log(block);
    var _b = block.format, src = _b.display_source, height = _b.block_height, width = _b.block_width;
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
        } },
        React.createElement("iframe", { src: src, style: {
                minHeight: '0px',
                height: "".concat(height, "px"),
                width: width,
                maxWidth: '100%',
                border: 'transparent'
            } })));
};
//# sourceMappingURL=iframe-componets.js.map